import { Component } from '@angular/core';
import { HelpContentComponent, HelpService } from '../../../UI-Lib/Help-Tooltip';
import { Address } from 'src/app/Common/Models/common.model';

export interface TaxPaymentAddressHelpComponentParams {
    address: Address;
    collectorName: string;
}

@Component({
    selector: 'tax-payment-address-help',
    templateUrl: './taxPaymentAddressHelp.component.html',
    standalone: false
})
export class TaxPaymentAddressHelpComponent implements HelpContentComponent<TaxPaymentAddressHelpComponentParams> {
    constructor(
        private readonly _helpService: HelpService) {
    }

    params: TaxPaymentAddressHelpComponentParams;
    address: Address;
    collectorName: string;

    async helpInit(params: TaxPaymentAddressHelpComponentParams): Promise<void> {
        this.address = params.address;
        this.collectorName = params.collectorName

        this._helpService.refresh();
    }
}
